export const filterArrayItemById = (array, filteredItemId) => array && array.filter(
  (item) => item.id !== filteredItemId
);